var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/HeaderLink/HeaderLink.jinja"] = require( "front/components/HeaderLink/HeaderLink.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["Contacts.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/HeaderLink/HeaderLink.jinja", false, "Contacts.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("HeaderLink", t_1);
output += "<div class=\"Contacts\">\n    <div class=\"Contacts-address\">\n        ";
output += runtime.suppressValue((lineno = 4, colno = 35, runtime.callWrap(runtime.memberLookup((t_1),"HeaderLink"), "HeaderLink[\"HeaderLink\"]", context, ["<p>OFFCON</p>" + runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"address"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"addressLink"),(lineno = 4, colno = 95, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Посмотреть на карте"])),runtime.makeKeywordArgs({"caller": (function (){var macro_t_4 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_5 = "";;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
return macro_t_4;})()})])), env.opts.autoescape);
output += "\n    </div>\n\n    <ul class=\"Contacts-list\">\n        <a class=\"Contacts-link u-Link\" href=\"tel:";
output += runtime.suppressValue(env.getFilter("replace").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"phone")," ",""), env.opts.autoescape);
output += "\"><span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"phone"), env.opts.autoescape);
output += "</span></a>\n        <a class=\"Contacts-link u-Link\" href=\"mailto:";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"email"), env.opts.autoescape);
output += "\"><span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"email"), env.opts.autoescape);
output += "</span></a>\n        <a class=\"Contacts-link u-Link\" href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "contacts")),"linkedinLink"), env.opts.autoescape);
output += "\" target=\"_blank\"><span>Linkedin</span></a>\n    </ul>\n\n    <footer class=\"Contacts-footer\">\n        <p>© 2015 OFFCON Architecture, Planning and Design</p>\n\n        <p>Designed in collaboration with Code and Theory</p>\n\n        <p>\n            Design by <a href=\"https://whiterussianstudio.com\" target=\"_blank\">WRS</a>,\n            Developed by <a href=\"https://astroshock.com/\" target=\"_blank\">Astroshock</a>\n        </p>\n    </footer>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["Contacts.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Contacts/Contacts.jinja
// module id = 79
// module chunks = 0